<script setup lang="ts">
import FaqList from '@components/util/faq/FaqList.vue';
import PanelPageContainer from '@components/layout/org&panel&support/PanelPageContainer.vue';

const contentStore = useContentStore();
const siteConfigs = useSiteConfigs();
const siteTitle = siteConfigs.title;
const title = `سؤالات متداول - ${siteTitle}`;
const desc = `مجموعه کاملی از سؤالات و پاسخ به آن‌ها که قبل یا بعد از خرید بلیط از ${siteTitle} به آن‌ها نیاز است.`;
useServerHead({
    link: [
        {
            rel: 'canonical',
            href: 'https://mrbilit.com/support/faq',
        },
    ],
});
await useAsyncData(async () => {
    try {
        await contentStore.getFaqs();
        return true;
    } catch (e) {
        reportException(e);
    }
});
useSeoMeta({
    title,
    description: desc,
    ogTitle: title,
    ogDescription: desc,
});

const items = computed<
    {
        title: string;
        items: Array<{
            title: string;
            value: string;
        }>;
    }[]
>(() =>
    contentStore.filteredFaqs.map(faq => ({
        items:
            faq.FaqItem?.map(faq => ({
                title: faq.question || '',
                value: faq.answer || '',
            })) || [],
        title: '',
    }))
);
</script>

<template>
    <PanelPageContainer retain-box-in-mobile title="پرسش‌های متداول">
        <div class="content" dir="rtl">
            <FaqList :items />
        </div>
    </PanelPageContainer>
</template>

<style scoped lang="scss">
.content {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 8px 0;
}
</style>
